<div class="signup-page">
  <div class="brand-logo">Flwx</div>

  <div class="signup-wrapper">
    <div class="card signup-card shadow-sm border-0">
      <div class="card-body p-4 p-md-4">

        <div class="credit-banner">
          <div class="credit-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </div>
          <div class="credit-text">
            Sign up today and receive <span class="credit-amount">$25</span> in free startup credits
            <span class="credit-sub">— no credit card required</span>
          </div>
        </div>

        <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">First Name</label>
              <input type="text" class="form-control" formControlName="firstName" [class.is-invalid]="signupForm.get('firstName')?.invalid && signupForm.get('firstName')?.touched" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Last Name</label>
              <input type="text" class="form-control" formControlName="lastName" [class.is-invalid]="signupForm.get('lastName')?.invalid && signupForm.get('lastName')?.touched" />
            </div>

            <div class="col-12">
              <label class="form-label">Company Name</label>
              <input type="text" class="form-control" formControlName="companyName" [class.is-invalid]="signupForm.get('companyName')?.invalid && signupForm.get('companyName')?.touched" />
            </div>

            <div class="col-12">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" formControlName="email" [class.is-invalid]="signupForm.get('email')?.invalid && signupForm.get('email')?.touched" />
            </div>

            <div class="col-12">
              <label class="form-label">Address</label>
              <input type="text" class="form-control" formControlName="address" [class.is-invalid]="signupForm.get('address')?.invalid && signupForm.get('address')?.touched" />
            </div>

            <div class="col-12">
              <label class="form-label">Address 2 [Optional]</label>
              <input type="text" class="form-control" formControlName="address2" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Phone</label>
              <input type="text" class="form-control" formControlName="phone" [class.is-invalid]="signupForm.get('phone')?.invalid && signupForm.get('phone')?.touched" />
            </div>

            <div class="col-md-6">
              <label class="form-label">State</label>
              <select class="form-select" formControlName="state" [class.is-invalid]="signupForm.get('state')?.invalid && signupForm.get('state')?.touched">
                <option value="">Select State</option>
                @for (st of usStates; track st.isoCode) {
                  <option [value]="st.isoCode">{{ st.name }} ({{ st.isoCode }})</option>
                }
              </select>
            </div>

            <div class="col-md-6">
              <label class="form-label">City</label>
              <input type="text" class="form-control" formControlName="city" [class.is-invalid]="signupForm.get('city')?.invalid && signupForm.get('city')?.touched" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Zip</label>
              <input type="text" class="form-control" formControlName="zip" [class.is-invalid]="signupForm.get('zip')?.invalid && signupForm.get('zip')?.touched" />
            </div>

            @if (errorMessage()) {
              <div class="col-12">
                <div class="alert alert-danger mb-0 py-2">{{ errorMessage() }}</div>
              </div>
            }

            <div class="col-12 pt-2">
              <button type="submit" class="btn btn-primary w-100 signup-btn" [disabled]="isSubmitting()">
                {{ isSubmitting() ? 'Submitting...' : 'SIGNUP' }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="welcome-text">
      Welcome to <span class="brand-badge">F</span> <strong>FlwX</strong>
    </div>

    <div class="login-text">
      Already have an account?
      <a routerLink="/auth/login">Login</a>
    </div>
  </div>
</div>

@if (showSuccessModal()) {
  <div class="modal-overlay">
    <div class="modal-dialog-custom">
      <div class="modal-content-custom">
        <div class="modal-header-custom success">
          <div class="icon-circle">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h3>Registration Successful</h3>
        </div>
        <div class="modal-body-custom">
          <p>The company has been created successfully.</p>
          <p>The company user has been created, your email will be your user and the password has been sent on your registered email address.</p>
        </div>
        <div class="modal-footer-custom">
          <button type="button" class="btn btn-primary w-100" (click)="onSuccessOk()">OK</button>
        </div>
      </div>
    </div>
  </div>
}